import { AccountProfile } from './profileModel';

export function isAgency(profile: AccountProfile) {
    return profile.organizationType === 'ad_agency';
}
